import {
    GET_ALL_USER_REGION_REQUEST, GET_ALL_USER_REGION_ERROR, GET_ALL_USER_REGION_SUCCESS,
    ADD_USER_REGION_REQUEST, ADD_USER_REGION_ERROR, ADD_USER_REGION_SUCCESS,
    UPDATE_USER_REGION_REQUEST, UPDATE_USER_REGION_ERROR, UPDATE_USER_REGION_SUCCESS,
    DELETE_USER_REGION_REQUEST, DELETE_USER_REGION_ERROR, DELETE_USER_REGION_SUCCESS,
} from "./types.js";
import { BASEURL } from "../../constant/config.js"
import axios from "axios";


export const getAllUserRegion = (token, userId, data) => dispatch => {

    dispatch({ type: GET_ALL_USER_REGION_REQUEST })
    return axios({
        method: "POST",
        url: `${BASEURL}getAll/UserRegion`,

        headers: {
            Accept: "application/json",
            'Authorization': 'Bearer ' + token
        },
    })
        .then(response => {
            return dispatch({ type: GET_ALL_USER_REGION_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            return dispatch({
                type: GET_ALL_USER_REGION_ERROR,
                payload: error.response,
            });
        })

}

export const addUserRegion = (token, data, menu_id) => (dispatch) => {
    dispatch({ type: ADD_USER_REGION_REQUEST });
    return axios({
        method: "POST",
        url: `${BASEURL}create/UserRegion`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
        data: { user_id: data.user_id, region_id: data.region_id, is_active: data.check, menu_id },
    })
        .then((response) => {
            return dispatch({ type: ADD_USER_REGION_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            return dispatch({
                type: ADD_USER_REGION_ERROR,
                payload: error.response,
            });
        });
};

export const updateUserRegion = (token, data, id) => (dispatch) => {
    dispatch({ type: UPDATE_USER_REGION_REQUEST });
    return axios({
        method: "PUT",
        url: `${BASEURL}update/UserRegion/${id}`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
        data: { user_id: data.user_id, region_id: data.region_id, is_active: data.check },
    })
        .then((response) => {
            return dispatch({ type: UPDATE_USER_REGION_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            return dispatch({
                type: UPDATE_USER_REGION_ERROR,
                payload: error.response,
            });
        });
};

export const deleteUserRegion = (token, id) => (dispatch) => {
    dispatch({ type: DELETE_USER_REGION_REQUEST });
    return axios({
        method: "DELETE",
        url: `${BASEURL}delete/UserRegion/${id}`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
    })
        .then((response) => {
            return dispatch({ type: DELETE_USER_REGION_ERROR, payload: response.data });
        })
        .catch((error) => {
            return dispatch({
                type: DELETE_USER_REGION_SUCCESS,
                payload: error.response,
            });
        });
};